import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M18 10.75c-.41 0-.75-.34-.75-.75V8a5.25 5.25 0 1 0-10.5 0v2c0 .41-.34.75-.75.75s-.75-.34-.75-.75V8c0-3.72 3.03-6.75 6.75-6.75S18.75 4.28 18.75 8v2c0 .41-.34.75-.75.75" }, null, -1),
    _createElementVNode("path", { d: "M17 22.75H7c-3.44 0-4.75-1.31-4.75-4.75v-4c0-3.44 1.31-4.75 4.75-4.75h10c3.44 0 4.75 1.31 4.75 4.75v4c0 3.44-1.31 4.75-4.75 4.75" }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M12 14c-.83 0-1.5.67-1.5 1.5S11.17 17 12 17s1.5-.67 1.5-1.5S12.83 14 12 14",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }